module.exports = __webpack_public_path__ + "img/logistic-robot.fc0652a0.png";